import { Body1, Card, Title4, YStack } from "@medbillai/ui";

// The onboarding stat tile (headline number + supporting line) — one source of
// truth for the surface/typography treatment across onboarding flows.
export function StatCard({
  headline,
  body
}: {
  headline: string;
  body: string;
}) {
  return <Card flex={1} flexBasis={0} backgroundColor="$surface0" borderWidth={0} data-sentry-element="Card" data-sentry-component="StatCard" data-sentry-source-file="StatCard.tsx">
      <YStack gap="$sp1" data-sentry-element="YStack" data-sentry-source-file="StatCard.tsx">
        <Title4 data-sentry-element="Title4" data-sentry-source-file="StatCard.tsx">{headline}</Title4>
        <Body1 color="$textSubtle" data-sentry-element="Body1" data-sentry-source-file="StatCard.tsx">{body}</Body1>
      </YStack>
    </Card>;
}